import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'CenteredPage',
    props: {
        backgroundFade: Boolean,
        disableMaxWidth: Boolean,
        expand: Boolean,
        expandMobile: Boolean,
        fillHeight: Boolean,
        innerClass: {
            type: String,
            default: null,
        },
        innerVerticalMargin: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const classNames = computed(() => {
            const names = [];
            if (props.backgroundFade)
                names.push('CenteredPage--background-fade');
            if (!props.disableMaxWidth)
                names.push('CenteredPage--with-max-width');
            if (props.expand)
                names.push('CenteredPage--expand');
            if (props.expandMobile)
                names.push('CenteredPage--expand-mobile');
            if (props.fillHeight)
                names.push('CenteredPage--fill-height');
            if (props.innerVerticalMargin)
                names.push('CenteredPage--vertical-margin');
            return names;
        });
        return {
            classNames,
        };
    },
});

export { script as default };
